import store from "../store";


const common_mt = {};

common_mt.mt_host = 'https://api.wapg.cn/meituan';
//授权注册美团的pid
common_mt.regist_meituan_pid = common_mt.mt_host + '/RegistPid';
//用户可提款金额接口
common_mt.user_pay_to = common_mt.mt_host + '/UserPayTo';
//用户提款明细接口
common_mt.user_pay_list = common_mt.mt_host + '/UserPayLists';
//下下级昨天本月数据接口（预估收入）
common_mt.pid_level_count_list = common_mt.mt_host + '/PidLevelCountListNew';
//每日预估收入按日期
common_mt.get_everyday_count_list = common_mt.mt_host + '/DayCount';
//下级层级 人数和收入
common_mt.level_count_data = common_mt.mt_host + '/LeveCountData';
// 订单详情接口地址(完成时间)
common_mt.get_order_by_Finish = common_mt.mt_host + '/orderByFinish';
//订单详情下载xls
common_mt.get_order_by_finish_xls = common_mt.mt_host + '/orderByFinishXls';
//获取提款纪录
common_mt.get_order_by_sumbit = common_mt.mt_host + '/orderBySubmit';
//获取用户收入
common_mt.order_count_new = common_mt.mt_host + '/orderCountNew';
//系统配置接口
common_mt.sub_config = common_mt.mt_host + '/SubConfig';
//订单详情接口地址(下单时间)
common_mt.get_order_list = common_mt.mt_host + '/orderListApi';



//=====================类似全局变量=========================
common_mt.back_from_count_new = false;
//提款操作来自于淘宝的数据页面
common_mt.pay_from_mt_data_page = false;
//预估佣金 私有比例
common_mt.commissionRate_pir = 0.55;



common_mt.getMtPid = function(){
    // return '9788668_131830157';
    if(store.state.meituan_pid && store.state.meituan_pid !== 'undefined'){
        return store.state.meituan_pid;
    }else {
        return '';
    }
}

export default common_mt;